export default `
  query getWorkflowHistory($projectId: String!, $workflowId: String!, $version: Int!) {
    getWorkflowHistory(projectId: $projectId, workflowId: $workflowId, version: $version) {
      id
      version
      name
      projectId
      status
      lanes {
        id
        name
      }
      schemas {
        id
        name
        description
        type
        cardinality
        boundedContext
        entityId
        domainEventIds
        fields {
          name
          description
          cardinality
          exampleData
          relatedEntityId
          type
          tags
          hideInForm
          computed
          dataType
          fields {
            name
            type
          }
        }
      }
      domainEvents {
        id
        laneId
        groupId
        description
        type
        conditionLabel
        version
        conditionLabels {
          parentId
          name
        }
        parents
        offset
        subprocess {
          id
          name
        }
        color {
          red
          green
          blue
          rgb
        }
        cards {
          id
          description
          creatorId
          created
          updated
          releaseNo
          sortkey
          done
          version
          creator {
            firstname
            lastname
            id
            picture {
              url
              file {
                key
              }
            }
          }
          reactions {
            direction
            user {
              id
              firstname
              lastname
              picture {
                url
                file {
                  key
                }
              }
            }
          }
          comments {
            id
            author {
              id
              firstname
              lastname
              picture {
                url
                file {
                  key
                }
              }
            }
            text
            dateCreated
            dateUpdated
            generatedByAi
          }
          attachments {
            id
            type
            url
            dateCreated
            name
            mimeType
            cardId
          }
          assignee {
            id
            firstname
            lastname
            picture {
              url
              file {
                key
              }
            }
          }
          cardTypeId
          cardType {
            id
            title
            domainModelRole
            color {
              red
              green
              blue
            }
          }
          boundedContext
          schemaId
        }
      }
    }
  }
`
